import React from 'react';

export default function MicrophoneIcon({ active = false, off = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Mic capsule */}
      <rect x="8.5" y="2" width="7" height="12" rx="3.5" stroke={stroke} strokeWidth="1.6" />
      {/* Stand arc */}
      <path d="M5 10.5C5 16 19 16 19 10.5" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      {/* Vertical line */}
      <line x1="12" y1="16" x2="12" y2="20" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      {/* Base */}
      <line x1="9" y1="20" x2="15" y2="20" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      {/* Slash-through when muted */}
      {off && (
        <line x1="2" y1="2" x2="22" y2="22" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      )}
    </svg>
  );
}
